<div
  class="d-flex flex-column align-items-center justify-content-lg-center vh-100"
>
  <div
    class="d-flex flex-column flex-lg-row align-items-center justify-content-center"
  >
    <img
      class="mx-5 mt-4"
      [src]="environment.serverFolder + 'assets/svg/fit-factory-logo.svg'"
      height="250"
      width="250"
      alt="fit factory logo"
    />

    <div class="col-10 col-lg-5 text-center">
      <span class="fw-bold fs-1 text-center"
        >Registro completado con éxito.
      </span>
      <span class="fw-bold" style="font-size: 2.5rem">¡Bienvenido!</span>
    </div>
  </div>
  <span class="fs-3 mt-4 text-center"
    >¡Ya hemos verificado tu email y puedes entrar a la app!</span
  >
</div>
